import apiService from '../../apiService'
import UserStore from '@stores/UserStore'
import {
  IGetTopicList,
  IGetPostList,
  INewCommentOrReplyParams,
  IPostCommentParams,
  ISavePostParams,
  ItopicManagersBoard,
} from './interface'

const prefix = '/learn/app/clientapi/iknow/'
const URL = {
  // 圈子相关
  getTopicList: `${prefix}topic/queryByPage.do`,
  topicFollowOrCancel: `${prefix}topic/followOrCancel.do`,
  getManageTopicIdList: `${prefix}topic/queryMyTopicIds.do`,
  getTopicDetail: `${prefix}topic/queryTopicDetailByTopicId.do`, // 查询帖子详情
  // 帖子评论相关
  deletePostComment: `${prefix}postComment/deleteById.do`, // 删除帖子评论
  likeOrCancelComment: `${prefix}postComment/likeOrCancelComment.do`, // 点赞/取消点赞评论
  newCommentOrReply: `${prefix}postComment/newCommentOrReply.do`, // 新增帖子评论或者评论的回复
  putOnOrOffPostComment: `${prefix}postComment/putOnOrOff.do`, // 上/下架帖子评论
  setHighQualityPostComment: `${prefix}postComment/upOrDownBest.do`, // 设为优质回帖
  postCommentList: `${prefix}postComment/queryByPage.do`, //  帖子评论列表接口-分页
  commentReplyList: `${prefix}postComment/queryReplyByPage.do`, // 查询帖子评论的回复-分页
  // 帖子相关
  deletePost: `${prefix}post/deleteById.do`, // 删除帖子
  getPostDetail: `${prefix}post/detail.do`, // 查询帖子详情
  //  我收藏的帖子列表接口-分页
  myCollectPostList: `${prefix}post/myCollectPost.do`,
  // 我的发帖列表接口-分页
  myPostList: `${prefix}post/myPost.do`,
  // 我的下架的帖子列表接口-分页
  myPutOffPostList: `${prefix}post/myPutOffPost.do`,
  // 我的回帖列表接口-分页
  myReplyPostList: `${prefix}post/myReplyPost.do`,
  // 我下架的评论和回复列表接口-分页
  myPutOffReplyList: `${prefix}/post/myPutOffReply.do`,
  // 上/下架帖子
  putOnOrOffPost: `${prefix}post/putOnOrOff.do`,
  // 收藏/取消收藏帖子
  collectOrCancelPost: `${prefix}post/collectOrCancel.do`,
  // 点赞/取消点赞帖子
  likeOrCancelPost: `${prefix}post/likeOrCancel.do`,
  // 圈子下的帖子列表接口-分页
  getPostList: `${prefix}post/queryByPage.do`,
  // 推荐的帖子列表接口-分页
  getRecommendList: `${prefix}post/queryRecommend.do`,
  // post 发布/编辑帖子
  savePost: `${prefix}post/savePost.do`,
  // 设置帖子简单属性，用于设置/取消精华，设置/取消公告，设置/取消置顶
  setSimpleProp: `${prefix}post/setSimpleProp.do`,
  // 上传知圈图片 post
  uploadImg: `${prefix}common/uploadImg.do`,
  // 上传知圈文件
  uploadFile: `${prefix}post/attachment/uploadFile.do`,
  // 查询帖子附件
  queryFileList: `${prefix}post/attachment/attachmentList.do`,
  // 圈主排行榜
  topicManagersBoard: `${prefix}topic/topicManagersBoard.do`,
  // 相关资源
  relatedResources: `${prefix}post/resource/findPostResource.do`,
  // 删除附件 deleteAttachment.do
  deletaFile: `${prefix}post/attachment/deleteAttachment.do`,
  // 获取圈子可见人员
  findPostResource: `${prefix}visible/findPostResource.do`,
  // 推送人员
  pushPeople: `${prefix}visible/peoplePush.do`,
  // 评论区推送人员
  commentPush: `${prefix}visible/commentPush.do`,
}

export default {
  // 获取圈子列表 -分页
  topicList: (data: IGetTopicList): Promise<any> => {
    return apiService.post(URL.getTopicList, data, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        sid: UserStore.getSid(),
      },
    })
  },
  // 关注/取消关注圈子
  topicFollowOrCancel: (topicId: string, isFollowed: number): Promise<any> => {
    return apiService.get(URL.topicFollowOrCancel, {
      topicId,
      isFollowed,
    })
  },
  // 查询我作为圈主可以管理的圈子ID列表，用于用户端的一些界面按钮隐藏、展示
  getManageTopicIdList: (): Promise<any> => {
    return apiService.get(URL.getManageTopicIdList)
  },
  // 查询圈子详情
  getTopicDetail: (topicId: string): Promise<any> => {
    return apiService.get(URL.getTopicDetail, { topicId })
  },
  // 获取推荐列表
  recommendList: (pageNo: number, pageSize: number): Promise<any> => {
    return apiService.get(URL.getRecommendList, {
      pageNo,
      pageSize,
    })
  },

  // 获取圈子下帖子列表
  postList: (data: IGetPostList): Promise<any> => {
    return apiService.post(URL.getPostList, data, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        sid: UserStore.getSid(),
      },
    })
  },

  // 帖子评论相关
  // 删除帖子评论
  deletePostComment: (postCommentId: string): Promise<any> => {
    return apiService.get(URL.deletePostComment, { postCommentId })
  },
  // 新增帖子评论或者评论的回复
  newCommentOrReply: (data: INewCommentOrReplyParams): Promise<any> => {
    return apiService.post(URL.newCommentOrReply, data, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        sid: UserStore.getSid(),
      },
    })
  },
  // 点赞/取消点赞评论
  likeOrCancelComment: (commentId: string): Promise<any> => {
    return apiService.get(URL.likeOrCancelComment, { commentId })
  },
  // 上/下架帖子评论
  putOnOrOffPostComment: (postCommentId: string): Promise<any> => {
    return apiService.get(URL.putOnOrOffPostComment, { postCommentId })
  },
  // 设为优质帖子评论
  setHighQualityPostComment: (postCommentId: string): Promise<any> => {
    return apiService.get(URL.setHighQualityPostComment, { postCommentId })
  },
  //  帖子评论列表接口-分页
  postCommentList: (data: IPostCommentParams): Promise<any> => {
    return apiService.post(URL.postCommentList, data, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        sid: UserStore.getSid(),
      },
    })
  },
  // 查询帖子评论的回复-分页
  commentReplyList: (
    postCommentId: string,
    pageNo: number,
    pageSize: number,
    skipRows: number
  ): Promise<any> => {
    return apiService.get(URL.commentReplyList, {
      postCommentId,
      pageNo,
      pageSize,
      skipRows,
    })
  },

  // 帖子相关
  // 删除帖子
  deletePost: (postId: string): Promise<any> => {
    return apiService.get(URL.deletePost, { postId })
  },
  // 查询帖子详情
  getPostDetail: (postId: string): Promise<any> => {
    return apiService.get(URL.getPostDetail, { postId })
  },
  // 我收藏的帖子列表接口-分页
  myCollectPostList: (pageNo: number, pageSize: number): Promise<any> => {
    return apiService.get(URL.myCollectPostList, {
      pageNo,
      pageSize,
    })
  },
  // 我的发帖列表接口-分页
  myPostList: (pageNo: number, pageSize: number): Promise<any> => {
    return apiService.get(URL.myPostList, {
      pageNo,
      pageSize,
    })
  },
  // 我的下架的帖子列表接口-分页
  myPutOffPostList: (pageNo: number, pageSize: number): Promise<any> => {
    return apiService.get(URL.myPutOffPostList, {
      pageNo,
      pageSize,
    })
  },
  // 我下架的评论列表和回复列表接口-分页
  myPutOffReplyList: (pageNo: number, pageSize: number): Promise<any> => {
    return apiService.get(URL.myPutOffReplyList, {
      pageNo,
      pageSize,
    })
  },
  // 我的回帖列表接口-分页
  myReplyPostList: (pageNo: number, pageSize: number): Promise<any> => {
    return apiService.get(URL.myReplyPostList, {
      pageNo,
      pageSize,
    })
  },
  // 上/下架帖子
  putOnOrOffPost: (postId: string): Promise<any> => {
    return apiService.get(URL.putOnOrOffPost, { postId })
  },
  // 收藏/取消收藏帖子
  collectOrCancelPost: (postId: string): Promise<any> => {
    return apiService.get(URL.collectOrCancelPost, { postId })
  },
  // 点赞/取消点赞帖子
  likeOrCancelPost: (postId: string): Promise<any> => {
    return apiService.get(URL.likeOrCancelPost, { postId })
  },
  // 发布/编辑帖子
  savePost: (data: ISavePostParams): Promise<any> => {
    return apiService.post(URL.savePost, data, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        sid: UserStore.getSid(),
      },
    })
  },
  // 设置帖子简单属性，用于设置/取消精华，设置/取消公告，设置/取消置顶
  setSimpleProp: (
    postId: string,
    propType: string,
    propValue: string
  ): Promise<any> => {
    return apiService.get(URL.setSimpleProp, {
      postId,
      propType,
      propValue,
    })
  },
  // 上传知圈图片
  uploadImg: (params: FormData): Promise<any> => {
    return apiService.post(
      URL.uploadImg,
      {
        file: params,
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          sid: UserStore.getSid(),
        },
      }
    )
  },
  // 上传知圈文件
  uploadFile: (params: FormData): Promise<any> => {
    return apiService.post(
      URL.uploadFile,
      {
        file: params,
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          sid: UserStore.getSid(),
        },
      }
    )
  },
  // 上传知圈文件
  queryFileList: (data: any): Promise<any> => {
    return apiService.get(URL.queryFileList, data, {
      headers: {
        'Content-Type': 'multipart/json;charset=UTF-8',
        sid: UserStore.getSid(),
      },
    })
  },
  // 删除文件
  deletaFile: (data: any): Promise<any> => {
    return apiService.get(URL.deletaFile, data, {
      headers: {
        'Content-Type': 'multipart/json;charset=UTF-8',
        sid: UserStore.getSid(),
      },
    })
  },
  // 圈主排行榜
  topicManagersBoard: (data: ItopicManagersBoard): Promise<any> => {
    return apiService.post(URL.topicManagersBoard, data, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        sid: UserStore.getSid(),
      },
    })
  },
  relatedResources: (data: any): Promise<any> => {
    return apiService.get(URL.relatedResources, data, {
      headers: {
        'Content-Type': 'multipart/json;charset=UTF-8',
        sid: UserStore.getSid(),
      },
    })
  },
  // 圈子可见性人员
  findPostResource: (data: any): Promise<any> => {
    return apiService.get(URL.findPostResource, data, {
      headers: {
        'Content-Type': 'multipart/json;charset=UTF-8',
        sid: UserStore.getSid(),
      },
    })
  },
  // 圈子可见性人员
  pushPeople: (data: any): Promise<any> => {
    return apiService.post(URL.pushPeople, data, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        sid: UserStore.getSid(),
      },
    })
  },
  // 圈子评论区推送人员
  commentPush: (data: any): Promise<any> => {
    return apiService.post(URL.commentPush, data, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
    })
  },
}
